<div class="utilities-calculator-component">
  <div class="d-flex justify-content-end pt-3 pr-3">
    <span class="cursor-pointer" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598">
        <path
          d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
          transform="translate(-7.873 -7.872)" />
      </svg>
    </span>
  </div>
  <div class="content-utilities">
    <div class="utilities-configuration-container">
      <p class="font-omicron-bold color-black title-header pb-2 title-size-1">
        Utilidad por pieza
      </p>
      <div class="product-utilities-content description-content">
        <div>
          <p class="font-omicron-bold color-black text-size-1">Producto</p>
          <p class="font-omicron-medium text-size-2">{{ data.itemCode }}</p>
        </div>
        <div>
          <p class="font-omicron-bold color-black text-size-1">Descripción</p>
          <p class="font-omicron-medium text-size-2">{{ data.description }}</p>
        </div>
      </div>
      <div class="calculation-utilities-content description-content">
        <div>
          <p class="font-omicron-bold color-black text-size-1">
            Costo <br> por pieza
          </p>
          <p class="font-omicron-medium text-size-2">
            ${{ data.costPerPiece | numberNotRound }}
          </p>
        </div>
        <div class="row">
          <div class="col">
            <p class="font-omicron-bold color-black text-size-1">
              Precio al público sugerido
            </p>
            <div class="input-utilities-container">
              <div class="font-omicron-bold color-black text-size-1">$</div>
              <input matInput [(ngModel)]="costPublic" (ngModelChange)="costPublicCalculed()"
                (input)="patternService.inputNumbersOnly($event, costPublic)" mask="separator.2" separatorLimit="999999"
                thousandSeparator="" autocomplete="off" [ngClass]="
                  disabledAccept ? 'input-number red-border' : 'input-number'
                " />
            </div>
          </div>
          <div class="col">
            <p class="font-omicron-bold color-black text-size-1">
              Margen <br> de utilidad
            </p>
            <div class="input-utilities-container">
              <input matInput [(ngModel)]="utilityPercentage" (ngModelChange)="utilitieCalculed()" (input)="
                  patternService.inputNumbersOnly($event, utilityPercentage)
                " mask="separator.2" separatorLimit="99" thousandSeparator="" [ngClass]="
                  disabledAccept ? 'input-number red-border' : 'input-number'
                " />
              <div class="font-omicron-bold color-black text-size-1">%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions-button-utilities">
      <button mat-stroked-button class="white-button font-size-button p-0 max-width-button-mobile" color="primary"
        (click)="closeModal()">
        Cancelar
      </button>
      <button mat-raised-button class="with-buttons font-size-button blue-button" color="primary" type="button"
        (click)="accept()" [disabled]="disabledAccept">
        Guardar
      </button>
    </div>
  </div>
</div>